import React from "react";
import { ShieldCheck, Microscope, HeartHandshake, BadgeCheck } from "lucide-react";
import { aboutBadges } from "../mock";

const ICONS = [BadgeCheck, Microscope, HeartHandshake, ShieldCheck];

export default function About() {
  return (
    <section id="about" className="relative px-4 md:px-8 pt-8 pb-4">
      <div className="relative mx-auto max-w-[1400px] rounded-[36px] bg-[#1a2464] text-white overflow-hidden">
        {/* wave pattern */}
        <div className="absolute inset-0 wave-pattern opacity-70 pointer-events-none" />
        <div className="absolute -top-24 -right-16 w-72 h-72 rounded-full bg-[#3dc9b3]/10 blur-3xl" />

        <div className="relative grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 p-8 md:p-14 lg:p-20">
          <div>
            <span className="inline-block bg-[#3dc9b3] text-white text-sm font-semibold px-5 py-2 rounded-full mb-6">About Us</span>
            <h2 className="text-4xl md:text-5xl lg:text-[3.4rem] font-bold leading-[1.1] tracking-tight">
              Beaudesert's dedicated<br />family healthcare team
            </h2>
          </div>
          <div className="text-white/80 leading-relaxed text-[15px] md:text-[16px] max-w-xl">
            <p className="mb-4">
              Beaudesert General Practice & Skin Care Clinic is the oldest and most established medical practice in the Beaudesert region. With more than 70 combined years of experience between our doctors, we deliver the highest quality of health care to thousands of patients each week.
            </p>
            <p>
              We are proud to be a member of the Beaudesert community, offering a broad range of services — from routine check-ups and vaccinations to skin excisions, cryotherapy and work-cover assessments — all under one roof.
            </p>
          </div>
        </div>

        {/* Badges */}
        <div className="relative grid grid-cols-2 lg:grid-cols-4 gap-6 px-8 md:px-14 lg:px-20 pb-14 md:pb-20">
          {aboutBadges.map((b, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <div key={b.title} className="flex items-start gap-4">
                <div className="shrink-0 w-14 h-14 rounded-full bg-white/10 grid place-items-center border border-white/10">
                  <Icon className="w-6 h-6 text-[#3dc9b3]" />
                </div>
                <div>
                  <div className="font-bold text-white text-[15px] leading-tight">{b.title}</div>
                  <div className="text-white/60 text-xs mt-1">{b.desc}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
